import request from "@/utils/request";

export function getOrgBySaleMan(data){
  return request({
    url:'/osp/org-sale/getOrgBySaleMan',
    method:'post',
    data: data
  })
}

export function getOrgByCustomer(data){
  return request({
    url:'/osp/org-sale/getOrgByCustomer',
    method:'post',
    data: data
  })
}

export function getOrgByAdmin(data){
  return request({
    url:'/osp/org-sale/getOrgByAdmin',
    method:'post',
    data: data
  })
}

/**
 * 查询所有销售组织（管理员用）
 */
export function queryAllSaleOrgs(data){
  return request({
    url:'/osp/org-sale/queryAll',
    method:'post',
    data: data
  })
}

/**
 * 根据父ID查询子销售组织（递归获取所有子组织）
 */
export function querySaleOrgChildren(data){
  return request({
    url:'/osp/org-sale/queryChildren',
    method:'post',
    data: data
  })
}
